var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCampaigns = function SvgCampaigns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 37,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21.5 21.5a3.417 3.417 0 1 0 0-6.833 3.417 3.417 0 0 0 0 6.833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.845 9.514 23.55 7.15h-4.1l-.295 2.364a8.8 8.8 0 0 0-2.055.852l-1.881-1.463-2.9 2.899 1.463 1.881a8.8 8.8 0 0 0-.852 2.055l-2.363.295v4.1l2.363.296c.198.726.487 1.415.852 2.055l-1.463 1.88 2.9 2.9 1.88-1.463a8.8 8.8 0 0 0 2.056.852l.295 2.364h4.1l.295-2.364a8.8 8.8 0 0 0 2.055-.852l1.881 1.463 2.9-2.9-1.464-1.88c.365-.64.654-1.329.853-2.055l2.363-.296v-4.1l-2.363-.295a8.8 8.8 0 0 0-.853-2.055l1.463-1.881-2.899-2.9-1.881 1.464a8.8 8.8 0 0 0-2.055-.852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M10.567 35.167H21.5a17.085 17.085 0 0 0 17.083-17.084V9.2M32.433 1H21.5A17.085 17.085 0 0 0 4.417 18.083v8.884"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m35.167 10.567 3.416-3.417L42 10.567M7.833 25.6l-3.416 3.417L1 25.6"
  })));
};
export default SvgCampaigns;